import { Injectable } from '@angular/core'
import { ActivatedRoute, NavigationExtras, Params, Router, UrlSerializer, UrlTree } from '@angular/router'

export interface GbNavigationOptions {
  activatedRoute?: ActivatedRoute
  newTab?: boolean
  extras?: NavigationExtras
  fragment?: string
  params?: Params
}

@Injectable({
  providedIn: 'root',
})
export class GbNavigationService {
  constructor(
    private router: Router,
    private urlSerializer: UrlSerializer,
  ) {}

  navigate(fragments: string[] | string, options: GbNavigationOptions = {}) {
    options.newTab
      ? this.newTabNavigation(fragments, options.activatedRoute, options.params)
      : this.sameTabNavigation(fragments, options.activatedRoute, options.extras, options.fragment, options.params)
  }

  sameTabNavigation(
    fragments: string[] | string,
    activatedRoute?: ActivatedRoute,
    extras?: NavigationExtras,
    fragment?: string,
    params?: Params,
  ) {
    const routeToNavigate = Array.isArray(fragments) ? fragments : [fragments]

    const tree = this.getTree(routeToNavigate, activatedRoute || this.router.routerState.root, params, fragment)

    this.router.navigateByUrl(tree, extras)

    if (fragment) {
      this.scrollToFragment(fragment)
    }
  }

  newTabNavigation(fragments: string[] | string, activatedRoute?: ActivatedRoute, params?: {}) {
    if (fragments instanceof Array) {
      const newTabUrl =
        window.location.origin + this.urlSerializer.serialize(this.getTree(fragments, activatedRoute, params))
      window.open(newTabUrl, '_blank')
    } else {
      const fullUrl =
        window.location.origin + this.urlSerializer.serialize(this.getTree(fragments, activatedRoute, params))
      window.open(fullUrl, '_blank')
    }
  }

  getTree(fragments: string[] | string, activatedRoute?: ActivatedRoute, params?: {}, fragment?: string): UrlTree {
    const routeToNavigate = fragments instanceof Array ? fragments : [fragments]

    const tree = this.router.createUrlTree(routeToNavigate, {
      relativeTo: activatedRoute,
      queryParams: params,
      fragment: fragment,
    })

    // reverse encoding from createUrlTree so query params included as part of
    // string are in readable form i.e. ?itemType= instead of %3FitemType%3D
    const decodedUrl = decodeURIComponent(this.urlSerializer.serialize(tree))

    return this.router.parseUrl(decodedUrl)
  }

  // Below is needed as angular router is not able to immediately scoll to the element with
  // id matching the provided fragment. This is a workaround to scroll to the element after routing.
  // @todo also get this working on new tab navigation

  scrollToFragment(fragment: string) {
    setTimeout(() => {
      let el = document.getElementById(fragment)
      if (el) el.scrollIntoView()
    }, 0)
  }
}
